export default {
  // 页面标题
  'pages.accountB.config.title': 'b账配置',

  // 按钮
  'pages.accountB.config.addDevice': '新增设备',
  'pages.accountB.config.editDevice': '编辑设备',
  'pages.accountB.config.query': '查询',
  'pages.accountB.config.reset': '重置',
  'pages.accountB.config.save': '保存',
  'pages.accountB.config.cancel': '取消',
  'pages.accountB.config.confirm': '确定',
  'pages.accountB.config.back': '返回',
  'pages.accountB.config.saveConfig': '保存配置',
  'pages.accountB.config.batchModify': '一键修改配置',

  // 搜索区
  'pages.accountB.config.search.tenant': '租户',
  'pages.accountB.config.search.tenant.placeholder': '请选择租户',
  'pages.accountB.config.search.store': '门店',
  'pages.accountB.config.search.store.placeholder': '请选择门店',
  'pages.accountB.config.search.device': '设备',
  'pages.accountB.config.search.device.placeholder': '请选择设备',

  // 列表列
  'pages.accountB.config.column.tenantId': '租户id',
  'pages.accountB.config.column.tenantName': '租户名称',
  'pages.accountB.config.column.storeName': '门店名称',
  'pages.accountB.config.column.industryType': '行业类型',
  'pages.accountB.config.column.deviceName': '设备名称',
  'pages.accountB.config.column.terminalNo': '终端号',
  'pages.accountB.config.column.discountRate': '下调比例',
  'pages.accountB.config.column.executionStrategy': '执行策略',
  'pages.accountB.config.column.action': '操作',
  'pages.accountB.config.action.edit': '修改',
  'pages.accountB.config.action.delete': '删除',
  'pages.accountB.config.action.detail': '明细',
  'pages.accountB.config.action.generate': '生成 B 账',
  'pages.accountB.config.generate.modalTitle': '生成 B 账数据',
  'pages.accountB.config.generate.dateRange': '日期范围',
  'pages.accountB.config.generate.confirm': '确定生成',
  'pages.accountB.config.generate.success': '生成成功,共处理 {n} 条',
  'pages.accountB.config.generate.fail': '生成失败',
  'pages.accountB.config.generate.needDateRange': '请选择日期范围',
  'pages.accountB.config.generate.force':
    '强制按最新规则重新生成(覆盖该范围内已有数据)',
  'pages.accountB.config.generate.force.tip':
    '勾选后会先删除所选范围内已生成的 B 账数据,再按当前配置的策略/折扣重新复制并应用规则。未勾选且范围内已有数据时会被拒绝。',
  'pages.accountB.config.generate.inProgress.title': '正在生成 B 账数据',
  'pages.accountB.config.generate.inProgress.tip':
    '正在复制订单/支付/班次/审计日志,并应用 B 账策略重算金额,预计 5~10 秒,请勿关闭此窗口。',
  'pages.accountB.config.generate.inProgress.largeRange':
    '如果日期范围跨越多天或数据量较大,可能耗时 30 秒以上。',

  // 删除确认
  'pages.accountB.config.deleteConfirm': '确定删除该配置？',

  // 编辑弹窗
  'pages.accountB.config.modal.editTitle': '销售价格策略',
  'pages.accountB.config.form.tenantName': '租户名称',
  'pages.accountB.config.form.storeName': '门店名称',
  'pages.accountB.config.form.deviceName': '设备名称',
  'pages.accountB.config.form.terminalNo': '终端号',
  'pages.accountB.config.form.terminalNo.placeholder': '自动导出',
  'pages.accountB.config.form.dateRange': '日期',
  'pages.accountB.config.form.selectPlaceholder': '请选择',

  // 下调与排除配置
  'pages.accountB.config.section.discount': '下调与排除配置',
  'pages.accountB.config.discountRate': '下调比例',
  'pages.accountB.config.discountRate.placeholder': '请输入下调比例',
  'pages.accountB.config.excludedPaymentMethods': '排除支付方式',
  'pages.accountB.config.excludeGovernmentDiscount': '政府折扣单处理模式',
  'pages.accountB.config.excludeGovernmentDiscount.desc':
    '选择 SC/PWD/NAAC/SP/MOV/Diplomatic 等政府折扣单在 B 账下调中的处理方式。',
  'pages.accountB.config.excludeGovernmentDiscount.mode.flatten':
    '扁平化并参与下调',
  'pages.accountB.config.excludeGovernmentDiscount.mode.flatten.desc':
    '政府折扣单按下调比例参与调整',
  'pages.accountB.config.excludeGovernmentDiscount.mode.keep': '保留原值不下调',
  'pages.accountB.config.excludeGovernmentDiscount.mode.keep.desc':
    '政府折扣单保持原值，不参与下调',
  'pages.accountB.config.returnInvalidOrder': '退货/作废订单',
  'pages.accountB.config.returnInvalidOrder.desc':
    '启用时，退货/作废订单不参与下调',
  'pages.accountB.config.enabled': '启用',
  'pages.accountB.config.disabled': '禁用',

  // 执行策略
  'pages.accountB.config.section.strategy': '执行策略',
  'pages.accountB.config.strategy.deleteLine': '扣除单品行',
  'pages.accountB.config.strategy.deleteLine.desc':
    '从订单中先行扣除部分商品，减少销售总额。适用场景:商品数量较多，需大幅缩减销售总额。(只有一个商品不适用)',
  'pages.accountB.config.strategy.replaceLow': '高价商品低价商品',
  'pages.accountB.config.strategy.replaceLow.desc':
    '将订单中的高价商品替换为低价商品，调整金额结构。适用场景:需保持商品数量不变，仅调整金额结构。',
  'pages.accountB.config.strategy.info':
    '当前策略会被定时Job用于修正销售订单、退货订单、交接班数据、日志文件和审计追踪文件。',

  // 现金管理
  'pages.accountB.config.section.cash': '现金管理',
  'pages.accountB.config.cashIn': '备用金',
  'pages.accountB.config.cashIn.placeholder': '请输入备用金',
  'pages.accountB.config.shortOverMin': 'Short/Over 最小值',
  'pages.accountB.config.shortOverMin.placeholder': '请输入最小值',
  'pages.accountB.config.shortOverMax': 'Short/Over 最大值',
  'pages.accountB.config.shortOverMax.placeholder': '请输入最大值',

  // 全选/清空
  'pages.accountB.config.selectAll': '全选',
  'pages.accountB.config.clearAll': '清空',

  // 配置日期弹窗
  'pages.accountB.config.dateModal.title': '选择应用日期',
  'pages.accountB.config.dateModal.month.placeholder': '请选择月份',
  'pages.accountB.config.dateColumn.date': '日期',
  'pages.accountB.config.dateColumn.status': '状态',
  'pages.accountB.config.dateColumn.strategy': '调整策略',
  'pages.accountB.config.dateColumn.adjustedOrderCount': '调整后订单数量',
  'pages.accountB.config.dateColumn.originalAmount': '原始金额',
  'pages.accountB.config.dateColumn.currentAmount': '当前金额',
  'pages.accountB.config.dateColumn.discountRate': '下调比例',
  'pages.accountB.config.dateColumn.action': '操作',
  'pages.accountB.config.dateAction.modify': '修改配置',
  'pages.accountB.config.dateAction.modifyDisabledTip':
    '本月 7 号后已锁定历史月份，不可修改',

  // 消息
  'pages.accountB.config.message.saveSuccess': '保存成功',
  'pages.accountB.config.message.saveFailed': '保存失败',
  'pages.accountB.config.message.deleteSuccess': '删除成功',
  'pages.accountB.config.message.deleteFailed': '删除失败',

  // 配置层级(列表列)
  'pages.accountB.config.column.configLevel': '配置层级',
  'pages.accountB.config.configLevel.machine': '机器级',
  'pages.accountB.config.configLevel.store': '门店级',

  // 门店设备(表单)
  'pages.accountB.config.form.posDevice': '门店设备',
  'pages.accountB.config.form.posDevice.placeholder': '请选择门店设备',
  'pages.accountB.config.form.posDevice.required': '请选择门店设备',
  'pages.accountB.config.form.posDevice.selectStoreFirst': '请先选门店',
  'pages.accountB.config.form.posDevice.noActivePos': '该门店暂无在用收银机',
  'pages.accountB.config.form.posDevice.bound': '已绑定',
  'pages.accountB.config.form.posDevice.storeLevelHint':
    '不选设备=门店级配置(整店共用);选择设备=机器级配置',

  // 访问验证
  'pages.accountB.config.auth.title': 'B账配置访问验证',
  'pages.accountB.config.auth.desc': '请输入访问密码',
  'pages.accountB.config.auth.placeholder': '请输入密码',
  'pages.accountB.config.auth.wrongPassword': '密码错误，请重新输入',

  // ===== B 账数据重置(超管专用)=====
  'pages.accountB.dataReset.cardTitle': '重置参数',
  'pages.accountB.dataReset.tenant': '租户',
  'pages.accountB.dataReset.store': '门店',
  'pages.accountB.dataReset.pos': 'POS 设备',
  'pages.accountB.dataReset.startMonth': '起始月份',
  'pages.accountB.dataReset.endMonth': '结束月份',
  'pages.accountB.dataReset.password': '操作口令',
  'pages.accountB.dataReset.tenant.placeholder': '选择目标租户(必填)',
  'pages.accountB.dataReset.tenant.placeholder.empty':
    '暂无 B 账配置,无可重置范围',
  'pages.accountB.dataReset.tenant.required': '请选择租户',
  'pages.accountB.dataReset.store.placeholder': '留空 = 该租户全部已配置门店',
  'pages.accountB.dataReset.pos.placeholder': '留空 = 该门店全部已配置 POS',
  'pages.accountB.dataReset.startMonth.required': '请选择起始月份',
  'pages.accountB.dataReset.endMonth.required': '请选择结束月份',
  'pages.accountB.dataReset.endMonth.beforeStart': '结束月份不能早于起始月份',
  'pages.accountB.dataReset.password.placeholder':
    '请联系平台管理员获取重置口令',
  'pages.accountB.dataReset.password.required': '请输入操作口令',
  'pages.accountB.dataReset.password.tooltip':
    '重置口令由平台管理员维护,经服务端 yaml 配置注入,源码不留明文',
  'pages.accountB.dataReset.submit': '执行 B 账数据重置',
  'pages.accountB.dataReset.submitTip': '点击后将弹出二次确认对话框',
  'pages.accountB.dataReset.alert.title':
    '危险操作:物理删除并重新生成 B 账数据',
  'pages.accountB.dataReset.alert.desc':
    '本功能为老客户初始化历史 B 账数据使用,将绕过次月 8 号锁定规则,物理删除所选范围内的全部 12+4 张 B 账表数据,并按当前配置覆盖式重新生成。操作不可撤销,请谨慎确认租户、门店、月份范围。下拉仅列出已配置 B 账策略的范围。',
  'pages.accountB.dataReset.confirm.title': '危险操作:确认重置 B 账数据?',
  'pages.accountB.dataReset.confirm.body':
    '此操作将物理删除并重新生成所选范围的 B 账数据,不可撤销。',
  'pages.accountB.dataReset.confirm.tenant': '租户',
  'pages.accountB.dataReset.confirm.store': '门店',
  'pages.accountB.dataReset.confirm.pos': 'POS',
  'pages.accountB.dataReset.confirm.monthRange': '月份范围',
  'pages.accountB.dataReset.confirm.ok': '我已确认,执行重置',
  'pages.accountB.dataReset.confirm.cancel': '取消',
  'pages.accountB.dataReset.allStores': '全店(已配置范围)',
  'pages.accountB.dataReset.allPos': '全 POS(已配置范围)',
  'pages.accountB.dataReset.tenantFallback': '租户 {id}',
  'pages.accountB.dataReset.storeFallback': '门店 {id}',
  'pages.accountB.dataReset.posFallback': 'POS {id}',
  'pages.accountB.dataReset.success':
    '重置成功:配置 {config} 条 / 生成 {days} 天 / 跳过 {skipped} 天 / 耗时 {ms}ms',
  'pages.accountB.dataReset.fail': '重置失败',
  'pages.accountB.dataReset.failWithMsg': '重置失败: {msg}',
};
